<template>
  <div>
    <v-dialog
      v-model="localDialog"
      max-width="550"
    >
      <v-card>
        <v-card-text class="dialog-title">Добавление игры</v-card-text>
        <v-card-actions>
          <div class="wrapper">
            <v-autocomplete
              v-model="selectedGame"
              :items="items"
              color="accent"
              class="field"
              :search-input.sync="searchInput"
              item-text="name"
              label="Поиск игры"
              return-object
              hide-no-data
              hide-details
            >
              <template #item="{ item }">
                <v-list-tile-avatar>
                  <img :src="item.image">
                </v-list-tile-avatar>
                <v-list-tile-title v-html="item.name" />
              </template>
            </v-autocomplete>

            <v-text-field
              ref="weightInput"
              v-model="weightInput"
              label="Позиция"
              color="accent"
              class="field-weight"
              type="number"
              :rules="[
                v => !!v || 'Поле обязательно для заполнения',
                v => (Number(v) >= 1 && Number(v) <= 100) || 'Значение должно быть от 1 до 100']"
            />
          </div>
        </v-card-actions>

        <v-card-actions>
          <div style="width: 100%; display: flex; justify-content: flex-end">
            <v-btn
              color="green darken-1"
              flat="flat"
              :disabled="isDisabled"
              @click="onClick"
            >
              Подтвердить
            </v-btn>

            <v-btn
              color="red darken-1"
              flat="flat"
              @click="$emit('cancel')"
            >
              Отмена
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { searchExternalGames } from '../../../api/games'

export default {
  name: 'GameModal',
  props: ['dialog', 'gameCounts'],
  data () {
    return {
      selectedGame: null,
      localDialog: this.dialog,
      searchInput: '',
      weightInput: '',
      items: [],
      limit: 15
    }
  },
  computed: {
    isDisabled () {
      return !(this.selectedGame && this.weightInput)
    }
  },
  watch: {
    dialog (val) {
      this.localDialog = val
    },
    localDialog (newVal) {
      if (!newVal) {
        this.$refs.weightInput.resetValidation()
        this.searchInput = ''
        this.weightInput = ''
        this.selectedGame = null
        this.items = []
      }

      this.$emit('update:localDialog', newVal)
    },
    searchInput (newValue) {
      if (this.selectedGame && newValue === this.selectedGame.name) return
      this.items = []
      if (newValue) {
        const trimmed = newValue.trim().replace(/ +/g, ' ')
        if (trimmed.length >= 3)
          searchExternalGames(trimmed, this.limit, 0).then(response => {
            this.items = response.data
          })
      }
    },
    selectedGame (newVal) {
      if (newVal)
        if (newVal.game_type === 'slots')
          this.weightInput = this.gameCounts.slots + 1
        else
          this.weightInput = this.gameCounts.live + 1
    }
  },
  methods: {
    onClick () {
      this.localDialog = false
      this.$emit('createGame', { game: this.selectedGame, weight: this.weightInput })
    }
  }
}
</script>

<style scoped>
.wrapper {
  width: 100%;
  display:flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 5px
}

.field {
  max-width: 300px;
}

.field-weight {
  margin-top: 20px;
  max-width: 150px;
}
</style>
